import { useState, useEffect } from "react";
import GlobalStyles from "./components/GlobalStyles";
import MarketingSite from "./pages/MarketingSite";
import LoginPage from "./pages/LoginPage";
import OnboardingFlow from "./pages/OnboardingFlow";
import Dashboard from "./pages/Dashboard";

// ─── APP ROUTER ───────────────────────────────────────────────────────────────
// Top-level view router for RevCentriQ.
// Views: marketing → login/signup → onboarding → dashboard
//
// Auth state lives here and is passed down to pages that need it.
// Phase 2: Replace useState with Supabase session listener.

// View type: "marketing" | "login" | "signup" | "onboarding" | "dashboard"

export default function App() {
  const [view, setView] = useState("marketing");
  const [user, setUser] = useState(null);
  const [transitioning, setTransitioning] = useState(true);

  // Fade in on mount
  useEffect(() => {
    setTimeout(() => setTransitioning(false), 100);
  }, []);

  // TODO Phase 2: Listen for Supabase session changes here
  // useEffect(() => {
  //   supabase.auth.onAuthStateChange((event, session) => {
  //     if (session) { setUser(session.user); navigate("dashboard"); }
  //     else { setUser(null); navigate("marketing"); }
  //   });
  // }, []);

  const navigate = (to) => {
    setTransitioning(true);
    setTimeout(() => {
      setView(to);
      setTransitioning(false);
    }, 220);
  };

  const handleAuthSuccess = (userData) => {
    setUser(userData);
    navigate(userData.isNew ? "onboarding" : "dashboard");
  };

  const handleOnboardComplete = (preferences) => {
    // TODO Phase 2: Save preferences to Supabase user profile
    console.log("Onboarding complete:", preferences);
    navigate("dashboard");
  };

  const handleLogout = () => {
    setUser(null);
    navigate("marketing");
  };

  return (
    <div
      style={{
        opacity: transitioning ? 0 : 1,
        transform: transitioning ? "translateY(8px)" : "translateY(0)",
        transition: "opacity .22s ease, transform .22s ease",
      }}
    >
      <GlobalStyles />

      {view === "marketing" && (
        <MarketingSite
          onLogin={() => navigate("login")}
          onSignup={() => navigate("signup")}
        />
      )}

      {(view === "login" || view === "signup") && (
        <LoginPage
          mode={view}
          onSuccess={handleAuthSuccess}
          onBack={() => navigate("marketing")}
        />
      )}

      {view === "onboarding" && user && (
        <OnboardingFlow
          user={user}
          onComplete={handleOnboardComplete}
        />
      )}

      {view === "dashboard" && (
        <Dashboard
          user={user}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
}
